import React from "react";
import useIsMobile from "../hooks/useIsMobile";
import CompaniesMobile from "../mobile/admin/CompaniesMobile";
import GestionCompanies from "./GestionCompanies";

export default function ResponsiveGestionCompanies(props) {
  return useIsMobile() ? <CompaniesMobile {...props} /> : <GestionCompanies {...props} />;
}
